import React from 'react';
import { colors, smallMobileMQ } from '../../modules/theme';
import { pixelToRem } from '../ui';

export default function RecordTab({ onChange, value }) {
  const tabs = [
    { label: 'Live Records', value: 'ALL' },
    { label: 'FrogID dataset 3.0', value: 'FIRST_YEAR', disabled: false },
  ];
  return (
    <div
      css={{
        background: 'white',
        border: `2px solid ${
          tabs.some(x => x.disabled) ? 'lightgrey' : colors.orange
          }`,
        padding: 2,
        width: '100%',
        maxWidth: 521,
        display: 'flex',
        borderRadius: '4px',
        margin: '0 auto 20px auto',
      }}
    >
      {tabs.map(x => {
        const isActive = x.value === value;
        const getCursor = () => {
          if (x.disabled) return 'not-allowed';
          return isActive ? undefined : 'pointer';
        };

        const getColor = () => {
          if (x.disabled) return 'lightgrey';
          return isActive ? 'white' : colors.orange;
        };
        return (
          <button
            key={x.value}
            disabled={x.disabled}
            css={{
              minHeight: 46,
              color: getColor(),
              background: isActive ? colors.orange : 'white',

              borderRadius: '4px',
              fontWeight: 'bold',
              lineHeight: '26pt',
              textAlign: 'center',
              border: 'none',
              width: '50%',
              fontSize: pixelToRem(22),
              cursor: getCursor(),
              padding: 10,
              [smallMobileMQ]: {
                padding: '2px 10px',
                fontSize: pixelToRem(18),
                lineHeight: '18px',
              },
            }}
            onClick={() => onChange(x.value)}
          >
            {x.label}
          </button>
        );
      })}
    </div>
  );
}
